@let blok = block();
@for (content of blok.content; track content._uid) {
    <s1-button [block]="content" class="w-full" />
}
